<template>
	<aside class="cart-box">
		<div class="cart-box-body">
			<div class="cart-box-total">
				<div class="cart-box-id wcb-box-totals">
					<span class="label"><BaseCmsLabel code="order_id" /></span>
					<span v-if="additionalPaymentRoute == 1 && additionalPayment">{{ additionalPayment.cart.order_id }}</span>
					<span v-else-if="orderData && orderData.cart">{{ orderData.cart.order_id }}</span>
				</div>
				<div class="cart-box-totals wcb-box-totals">
					<span class="label"><BaseCmsLabel code="payment_second_form_total" /></span>
					<span v-if="additionalPaymentRoute == 1 && additionalPayment"><BaseUtilsFormatCurrency :price="additionalPayment.total.total" /></span>
					<span v-else-if="orderData && orderData.total"><BaseUtilsFormatCurrency :price="orderData.total.total" /></span>
				</div>
				<div class="cart-box-note">
					<template v-if="additionalPaymentRoute == 1"><BaseCmsLabel code="bankart_payment_info_additpayment" /></template>
					<template v-else><BaseCmsLabel code="bankart_payment_info" /></template>
				</div>
			</div>

			<div class="buttons">
				<button v-if="checkoutLoading || creation" disabled class="btn btn-green btn-cart-box btn-icon-arrow btn-submit btn-spinner">
					<UiLoader class="dots" />
				</button>
				<div v-else-if="(!meta?.valid || !formValid) || orderData?.cart?.can_change_payment == false" class="btn btn-green btn-cart-box btn-submit disabled">
					<template v-if="additionalPaymentRoute == 1"><BaseCmsLabel code="confirm_payment_additpayment" /></template>
					<template v-else-if="props.mode == 'newPaymentMode'"><BaseCmsLabel code="confirm_new_payment" /></template>
					<template v-else><BaseCmsLabel code="paid" /></template>
				</div>
				<button v-else class="btn btn-green btn-cart-box btn-submit" type="submit">
					<template v-if="additionalPaymentRoute == 1"><BaseCmsLabel code="confirm_payment_additpayment" /></template>
					<template v-else-if="props.mode == 'newPaymentMode'"><BaseCmsLabel code="confirm_new_payment" /></template>
					<template v-else><BaseCmsLabel code="paid" /></template>
				</button>
				<div
					v-if="props.mode == 'newPaymentMode'"
					@click="cancelOrder()"
					:disabled="orderData && orderData.cart?.can_change_payment == false"
					class="btn btn-white btn-cart-box btn-icon-arrow btn-canceled-order"
					:class="{'btn-disabled' : !orderData || (orderData && orderData.cart?.can_change_payment == false)}">
					<span v-if="additionalPaymentRoute == 1"><BaseCmsLabel code="cancel_order_additpayment" /></span>
					<span v-else><BaseCmsLabel code="cancel_order" /></span>
				</div>
				<div v-else @click="newPaymentFunction()" class="btn btn-outline btn-cart-box btn-icon-arrow btn-canceled">
					<span><BaseCmsLabel code="canceled" /></span>
				</div>
			</div>
			<span v-if="(!meta?.valid || !formValid) || orderData?.cart?.can_change_payment == false" class="global-warning nobtns wc-box-btn-note"><BaseCmsLabel code="wc_next_step_note" /></span>
		</div>
	</aside>
</template>

<script setup>
	const webshop = useWebshop();
	const apiRoutes = useApiRoutes();
	const endpoints = useEndpoints();
	const labels = useLabels();
	const {emit} = useEventBus();
	const props = defineProps({
		mode: {
			type: String,
			default: '',
		},
		meta: Object,
		review: {
			type: null,
			default: false,
		},
		invalidSubmitNote: {
			type: null,
			default: false,
		},
	});

	const { creation, checkoutLoading, orderSuccess, newPayment, newPaymentOptions, newPaymentId, newPaymentCard, newPaymentInstallment, formValid, additionalPayment, additionalPaymentRoute, orderData } = useCheckout();

	async function cancelOrder() {
		if(!orderData?.value) {
			return console.error('Order data not found');
		}
		checkoutLoading.value = true;

		const id_code = (additionalPaymentRoute.value == 1) ? additionalPayment.value.cart.id + '-' + additionalPayment.value.cart.code : orderData.value.cart.order_id + '-' + orderData.value.cart.order_code;
		const webshopOrderId = (additionalPaymentRoute.value == 1) ? endpoints.get('_put_hapi_webshop_additionalpayment') : endpoints.get('_get_hapi_webshop_order');
		const webshopOrder = webshopOrderId.replace("%ID%-%CODE%", id_code);

		await useApi(webshopOrder, {method: 'PUT', body: {'status': 'otkazano'}}, {lang: false})
		.then(async (res) => {
			if(res.success) {
				orderSuccess.value = 1;
				newPayment.value = null;
				newPaymentOptions.value = null;
				newPaymentId.value = 0;
				newPaymentCard.value = 0;
				newPaymentInstallment.value = 1;
				if(additionalPaymentRoute.value == 1) {
					await navigateTo({
						path: apiRoutes.getAppUrl('webshop_failed_payment'),
						query: {order_identificator: id_code, webshopadditionalpayment: '1'}
					});
				} else {
					await navigateTo({
						path: apiRoutes.getAppUrl('webshop_failed_payment'),
						query: {order_identificator: id_code}
					});
				}
			}
		})

		checkoutLoading.value = false;
	}

	async function newPaymentFunction() {
		checkoutLoading.value = true;

		const id_code = (additionalPaymentRoute.value == 1) ? additionalPayment.value.cart.id + '-' + additionalPayment.value.cart.code : orderData.value.cart.order_id + '-' + orderData.value.cart.order_code;
		const webshopOrderId = (additionalPaymentRoute.value == 1) ? endpoints.get('_put_hapi_webshop_additionalpayment') : endpoints.get('_get_hapi_webshop_order');
		const webshopOrder = webshopOrderId.replace("%ID%-%CODE%", id_code);

		await useApi(webshopOrder + '?new_payment=1', {method: 'GET'})
		.then(async (res) => {
			if(res.success) {
				orderSuccess.value = 1
				if(additionalPaymentRoute.value == 1) {
					await navigateTo({
						path: apiRoutes.getAppUrl('webshop_payment_new'),
						query: {order_identificator: id_code, webshopadditionalpayment: '1'}
					});
					additionalPayment.value = res.data;
				} else {
					await navigateTo({
						path: apiRoutes.getAppUrl('webshop_payment_new'),
						query: {order_identificator: id_code}
					});
					orderData.value = res.data;
				}
			}
		})

		checkoutLoading.value = false;
	}
</script>

<style lang="less" scoped>
	.cart-box{padding-top: 20px;}
	.wcb-box-totals{display: flex; font-weight: bold;}
	.label{flex-shrink: 0; flex-grow: 0; width: 200px; font-weight: normal;}
	.cart-box-total{display: flex; flex-direction: column; gap: 10px;}
	.cart-box-note{margin: 30px 0; font-weight: bold; text-wrap: balance;}
	.buttons{
		display: flex; gap: 10px; margin-bottom: 25px;
		@media (max-width: @m){
			flex-direction: column;
		}
	}
	.wc-box-btn-note{margin: 0;}
	.btn{width: 100%;}
</style>
